import { Logo } from 'common/components/layout';
import { getCartTitle } from 'common/helpers/miscHelper';

const Header = (props) => {
  const { step, onMenuClick, settings } = props;

  return (
    <div className="c7-checkout__header">
      <Logo />

      {renderMenu(step, onMenuClick, settings)}
    </div>
  );
};

const renderMenu = (step, onMenuClick, settings) => {
  const title = getCartTitle(settings);
  const customerClick = (e) => {
    e.preventDefault();
    onMenuClick('customer');
  };
  const shippingClick = (e) => {
    e.preventDefault();
    onMenuClick('shipping');
  };
  const paymentClick = (e) => {
    e.preventDefault();
    onMenuClick('payment');
  };
  switch (step) {
    case 'customer': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href="/cart">{title}</a>
          </div>
          <div className="active" aria-current="step">
            Customer information
          </div>
          <div>Shipping method</div>
          <div>Payment information</div>
        </div>
      );
    }
    case 'carrierPickupLocation':
    case 'shipping': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href="/cart">{title}</a>
          </div>
          <div>
            <a
              href="#"
              aria-label="Customer information"
              onClick={customerClick}
            >
              Customer information
            </a>
          </div>
          <div className="active" aria-current="step">
            Shipping method
          </div>
          <div>Payment information</div>
        </div>
      );
    }
    case 'payment': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href="/cart">{title}</a>
          </div>
          <div>
            <a
              href="#"
              aria-label="Customer information"
              onClick={customerClick}
            >
              Customer information
            </a>
          </div>
          <div>
            <a href="#" aria-label="Shipping method" onClick={shippingClick}>
              Shipping method
            </a>
          </div>
          <div className="active" aria-current="step">
            Payment information
          </div>
        </div>
      );
    }
    case 'complete': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href="/cart">{title}</a>
          </div>
          <div>
            <a
              href="#"
              aria-label="Customer information"
              onClick={customerClick}
            >
              Customer information
            </a>
          </div>
          <div>
            <a href="#" aria-label="Shipping method" onClick={shippingClick}>
              Shipping method
            </a>
          </div>
          <div>
            <a href="#" aria-label="Payment information" onClick={paymentClick}>
              Payment information
            </a>
          </div>
        </div>
      );
    }
    default:
      throw new Error('Invalid Step');
  }
};

export default Header;
